import { render, staticRenderFns } from "./csimFormAttribute.vue?vue&type=template&id=543af578&scoped=true"
import script from "./csimFormAttribute.vue?vue&type=script&lang=js"
export * from "./csimFormAttribute.vue?vue&type=script&lang=js"
import style0 from "./csimFormAttribute.vue?vue&type=style&index=0&id=543af578&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543af578",
  null
  
)

export default component.exports